import { Icon } from '@wyz/ui';
import * as React from 'react';

type IconProps = React.ComponentProps<typeof Icon>;

type SeasonIconProps = {
  value: string | number;
  size?: IconProps['size'];
  /** CSS class to apply for custom styling */
  className?: string;
};

const SeasonIcon = ({ value, size = 'lg', className }: SeasonIconProps) => {
  const SEASON_ICONS: Record<number | string, React.ReactNode> = {
    'd29375ae-56bc-11ee-a9a9-02e6f75554a1': (
      <Icon icon='sun' color='orange' size={size} className={className} />
    ),
    1: <Icon icon='sun' color='orange' size={size} className={className} />,
    'Ete': <Icon icon='sun' color='orange' size={size} className={className} />,
    'd29377ae-56bc-11ee-a9a9-02e6f75554a1': (
      <Icon icon='flake' size={size} className={className} />
    ),
    2: <Icon icon='flake' size={size} className={className} />,
    'Hiver': <Icon icon='flake' size={size} className={className} />,
    'd293782e-56bc-11ee-a9a9-02e6f75554a1': (
      <Icon icon='four-season' size={size} className={className} />
    ),
    3: <Icon icon='four-season' size={size} className={className} />,
    '4S': <Icon icon='four-season' size={size} className={className} />,
  };

  return <>{SEASON_ICONS[value]}</>;
};

export default SeasonIcon;
